import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AuthRuntimeConfig, loadAuthRuntimeConfig } from './auth-config';
import { authInterceptor } from './auth.interceptor';
import { AuthService } from './auth.service';

export function provideAuth(
  configLoader: () => AuthRuntimeConfig = loadAuthRuntimeConfig,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(async () => {
      const auth = inject(AuthService);
      const config = configLoader();
      await auth.initialize(config);
    }),
    provideHttpClient(withInterceptors([authInterceptor])),
  ]);
}
